import { Image } from 'react-native';

const images = {
  logo: Image.resolveAssetSource(require('../Assets/images/white.png')),
  logoRed: Image.resolveAssetSource(require('../Assets/images/red.png')),
};

export default images;
